import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	leaveFeedback: {
		defaultMessage: 'Give feedback',
		id: 'platform.feedback.feedback-collector.button.leave-feedback',
		description: 'The button text that allows users to give feedback',
	},
});
